import { getActiveCarrierId } from './workforceBff';
// The existing fetch bridge supplies carrier context to every Express call.
async function call(method, path, body, options = {}) {
  const carrierId = getActiveCarrierId();
  try {
    const { supabase } = await import('./supabaseClient');
    const { data: { session } } = await supabase.auth.getSession();
    if (carrierId !== getActiveCarrierId() || options.signal?.aborted) throw new DOMException('Cancelled', 'AbortError');
    const headers = { ...(body ? { 'Content-Type': 'application/json' } : {}),
      ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}) };
    const response = await fetch(`/api${path}`, { method, headers, signal: options.signal,
      ...(body ? { body: JSON.stringify(body) } : {}) });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new Error(data.error || 'درخواست قواعد انجام نشد. دوباره تلاش کنید.');
      error.code = data.code;
      error.status = response.status;
      throw error;
    }
    return data;
  } catch (error) {
    if (error.name === 'AbortError' || error.status) throw error;
    throw new Error('ارتباط با سامانه برقرار نشد. دوباره تلاش کنید.');
  }
}
const enc = encodeURIComponent;
export const listRulebooks = (options) => call('GET', '/rulebook-prompts', undefined, options);
export const getRulebookVersion = (id, options) => call('GET', `/rulebook-prompts/versions/${enc(id)}`, undefined, options);
export const createRulebookDraft = (categoryId, body, options) => call('POST', `/rulebook-prompts/${enc(categoryId)}/drafts`, body, options);
export const saveRulebookDraft = (id, body, options) => call('PUT', `/rulebook-prompts/versions/${enc(id)}`, body, options);
export const publishRulebook = (id, note, options) => call('POST', `/rulebook-prompts/versions/${enc(id)}/publish`, { note }, options);
export const deleteRulebookDraft = (id, options) => call('DELETE', `/rulebook-prompts/versions/${enc(id)}`, undefined, options);
export const listRulebookCopySources = (categoryId, options) => call('GET', `/rulebook-prompts/copy-sources?category_id=${enc(categoryId)}`, undefined, options);
export const listRulebookCategories = (options) => call('GET', '/rulebook-categories', undefined, options);
